var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#FF6D00;}.b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.311)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "a",
    cx: 20.5,
    cy: 21,
    rx: 20.5,
    ry: 21,
    transform: "translate(0.311)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.576 1.575)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.077,29.225a.541.541,0,0,1-.4-.173.588.588,0,0,1-.173-.484l.76-5.254a.541.541,0,0,1,.161-.323L20.651,8.741a.611.611,0,0,1,.818,0l4.516,4.516a.576.576,0,0,1,.161.4.6.6,0,0,1-.161.415L11.837,28.269a.507.507,0,0,1-.323.161l-5.3.783Zm1.29-5.553-.611,4.3,4.343-.645L24.764,13.672l-3.71-3.71Z",
    transform: "translate(1.661 2.131)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M11.23,26.6a.541.541,0,0,1-.4-.161l-4.5-4.5a.576.576,0,0,1,0-.818.588.588,0,0,1,.818,0l4.5,4.5a.588.588,0,0,1,0,.818A.576.576,0,0,1,11.23,26.6Z",
    transform: "translate(1.76 4.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.477,18.228a.576.576,0,0,1-.415-.161.588.588,0,0,1,0-.818l6.486-6.486a.588.588,0,0,1,.818,0,.576.576,0,0,1,0,.818L15.88,18.066a.541.541,0,0,1-.4.161Z",
    transform: "translate(3.09 2.437)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M24.65,13.3a.588.588,0,0,1-.415-.173L19.891,8.772a.6.6,0,0,1-.161-.392.576.576,0,0,1,.161-.4l2.3-2.3a.576.576,0,0,1,.818,0l4.355,4.355a.588.588,0,0,1,.173.415.541.541,0,0,1-.173.4l-2.3,2.3A.576.576,0,0,1,24.65,13.3ZM21.113,8.38l3.537,3.525,1.463-1.463L22.587,6.894Z",
    transform: "translate(3.826 1.662)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditar);
export default __webpack_public_path__ + "static/media/editar.8961cdf6169340aaf966367022f3ae9b.svg";
export { ForwardRef as ReactComponent };